import Nullstack from 'nullstack';
export default function IconLayersIntersect2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-layers-intersect-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "8",
    y: "4",
    width: "12",
    height: "12",
    rx: "2"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "8",
    width: "12",
    height: "12",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M9 15l6 -6"
  }), " ");
}